"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Method22 = void 0;

var _dateUtil = require("./date-util");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
  Method 22 fields look like this (type emission_observation)
  [{
    "id":"5369fad6-6519-4324-87d6-81515fe8af5c",
    "observationMinutes":2,
    "observationSeconds":0,
    "emissionMinutes":0,
    "emissionSeconds":0,
    "startTime":"1402"
  },
  ...
]
*/
var Keys;

(function (Keys) {
  Keys["OBSERVATION_MINUTES_KEY"] = "observationMinutes";
  Keys["OBSERVATION_SECONDS_KEY"] = "observationSeconds";
  Keys["EMISSION_MINUTES_KEY"] = "emissionMinutes";
  Keys["EMISSION_SECONDS_KEY"] = "emissionSeconds";
})(Keys || (Keys = {}));

// turns [16, 23] into 16:24 and [2, 3] into 02:03
function formatDigitalTime(numbers) {
  if (!numbers.length) return '';
  var withPaddedZeroes = "0".concat(numbers[0]).slice(-2);

  for (var i = 1; i < numbers.length; i += 1) {
    var zeroPaddedNumber = "0".concat(numbers[i]).slice(-2);
    withPaddedZeroes += ":".concat(zeroPaddedNumber);
  }

  return withPaddedZeroes;
}

var Method22 = /*#__PURE__*/function () {
  function Method22(observations) {
    _classCallCheck(this, Method22);

    _defineProperty(this, "observations", void 0);

    this.observations = observations;
  }

  _createClass(Method22, [{
    key: "totalTimeInSeconds",
    value: function totalTimeInSeconds(minutesKey, secondsKey) {
      return this.observations.reduce(function (acc, entry) {
        var seconds = 0;

        if (entry[minutesKey]) {
          seconds += entry[minutesKey] * 60;
        }

        if (entry[secondsKey]) {
          seconds += entry[secondsKey];
        }

        return acc + seconds;
      }, 0);
    }
  }, {
    key: "totalTimeInMinutesAndSeconds",
    value: function totalTimeInMinutesAndSeconds(minutesKey, secondsKey) {
      var allSeconds = this.totalTimeInSeconds(minutesKey, secondsKey);
      var minutes = Math.floor(allSeconds / 60);
      var seconds = allSeconds % 60;
      return [minutes, seconds];
    }
  }, {
    key: "emissionsFrequency",
    value: function emissionsFrequency() {
      var observationSeconds = this.totalTimeInSeconds(Keys.OBSERVATION_MINUTES_KEY, Keys.OBSERVATION_SECONDS_KEY);
      var emissionSeconds = this.totalTimeInSeconds(Keys.EMISSION_MINUTES_KEY, Keys.EMISSION_SECONDS_KEY);
      var emissionsRatio = observationSeconds > 0 && emissionSeconds > 0 ? emissionSeconds / observationSeconds : 0;
      return "".concat((emissionsRatio * 100).toFixed(1), "%");
    }
  }, {
    key: "totalObservationDuration",
    value: function totalObservationDuration() {
      return formatDigitalTime(this.totalTimeInMinutesAndSeconds(Keys.OBSERVATION_MINUTES_KEY, Keys.OBSERVATION_SECONDS_KEY));
    }
  }, {
    key: "totalEmissionDuration",
    value: function totalEmissionDuration() {
      return formatDigitalTime(this.totalTimeInMinutesAndSeconds(Keys.EMISSION_MINUTES_KEY, Keys.EMISSION_SECONDS_KEY));
    }
  }, {
    key: "endTimeAsDate",
    value: function endTimeAsDate() {
      var lastEntry = this.observations[this.observations.length - 1];

      var _ref = lastEntry !== null && lastEntry !== void 0 ? lastEntry : {},
          startTime = _ref.startTime,
          observationMinutes = _ref.observationMinutes;

      var observationSeconds = this.observations.reduce(function (acc, entry) {
        return entry.observationSeconds + acc;
      }, 0);
      var endTime = null;

      if (startTime && observationMinutes) {
        var _endTime, _endTime2;

        endTime = (0, _dateUtil.timeToDate)(startTime);
        (_endTime = endTime) === null || _endTime === void 0 ? void 0 : _endTime.setSeconds(endTime.getSeconds() + observationSeconds);
        (_endTime2 = endTime) === null || _endTime2 === void 0 ? void 0 : _endTime2.setMinutes(endTime.getMinutes() + observationMinutes);
      }

      return endTime;
    }
  }, {
    key: "endTimeAsString",
    value: function endTimeAsString() {
      var endDate = this.endTimeAsDate();
      if (!endDate) return '';
      var endHours = "0".concat(endDate.getHours()).slice(-2);
      var endMinutes = "0".concat(endDate.getMinutes()).slice(-2);
      return "".concat(endHours).concat(endMinutes);
    }
  }], [{
    key: "startTimeAsString",
    value: function startTimeAsString(observation) {
      return observation.startTime;
    }
  }, {
    key: "observationDuration",
    value: function observationDuration(observation) {
      return formatDigitalTime([observation.observationMinutes, observation.observationSeconds]);
    }
  }, {
    key: "emissionDuration",
    value: function emissionDuration(observation) {
      return formatDigitalTime([observation.emissionMinutes, observation.emissionSeconds]);
    }
  }]);

  return Method22;
}();

exports.Method22 = Method22;